const routes = [
  {
    path: '/',
    name: 'AdminLogin',
    component: () => import('../components/Login/AdminLogin.vue')
  },
  {
    path: '/login',
    name: 'AdminLogin',
    component: () => import('../components/Login/AdminLogin.vue')
  },
  {
    path: '/password-forgot',
    name: 'AdminForgotPassword',
    component: () => import(/* webpackChunkName: "about" */'../components/ForgotPassword/AdminForgotPassword.vue')
  },
  {
    path: '/forgot-password-success',
    name: 'AdminForgotPasswordSuccess',
    component: () => import(/* webpackChunkName: "about" */'../components/ForgotPassword/AdminForgotPasswordSuccess.vue')
  },
  {
    path: '/employeeLogin',
    name: 'EmployeeLogin',
    component: () => import(/* webpackChunkName: "about" */ '../components/Login/EmployeeLogin.vue')
  },
  {
    path: '/forgotPin',
    name: 'ForgotPin',
    component: () => import(/* webpackChunkName: "about" */ '../components/ForgotPassword/ForgotPin.vue')
  },
  {
    path: '/transactionAmount',
    name: 'TransactionAmount',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/TerminalUser/TransactionAmount.vue')
  },
  {
    path: '/confirmTotalAmount/:amount',
    name: 'ConfirmTotalAmount',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/TerminalUser/ConfirmTotalAmount.vue')
  },
  {
    path: '/paymentMethod',
    name: 'PaymentMethod',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/TerminalUser/PaymentMethod.vue')
  },
  {
    path: '/enterPaymentCode/:amount',
    name: 'EnterPaymentCode',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/TerminalUser/EnterPaymentCode.vue')
  },
  {
    path: '/scanPaymentCode/:amount',
    name: 'Scanner',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/TerminalUser/Scanner.vue')
  },
  {
    path: '/reviewtotalamount',
    name: 'ReviewTotalAmount',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/TerminalUser/ReviewTotalAmount.vue')
  },

  {
    path: '/transactionCancelled',
    name: 'TransactionCancelled',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/TerminalUser/TransactionCancelled.vue')
  },
  {
    path: '/settings',
    name: 'Settings',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/StoreUser/Settings.vue')
  },
  {
    path: '/notifications',
    name: 'Notifications',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/Notifications/Notifications.vue')
  },
  {
    path: '/userlist',
    name: 'UserList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/StoreUser/UserList.vue')
  },
  {
    path: '/viewUser',
    name: 'ViewUser',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/StoreUser/ViewStoreUser.vue')
  },
  {
    path: '/addEditUser/:mode',
    name: 'AddEditUser',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/StoreUser/AddEditUser.vue')
  },
  {
    path: '/terminals',
    name: 'Terminals',
    component: () => import(/* webpackChunkName: "about" */ '../components/StoreUser/Terminals.vue')
  },
  {
    path: '/terminal/:mode',
    name: 'AddEditTerminal',
    component: () => import(/* webpackChunkName: "about" */ '../components/StoreUser/AddEditTerminal.vue')
  },
  {
    path: '/viewTerminal',
    name: 'ViewTerminal',
    component: () => import(/* webpackChunkName: "about" */ '../components/StoreUser/ViewTerminal.vue')
  },
  /** V1 Screen routes starts from here */
  {
    path: '/v1/tip',
    name: 'EnterTip',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/V1/EnterTip.vue')
  },
  {
    path: '/v1/confirmAmount',
    name: 'ConfirmAmount',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/V1/ConfirmAmount.vue')
  },
  {
    path: '/v1/paymentMethod',
    name: 'PaymentMethod',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/V1/PaymentMethod.vue')
  },
  {
    path: '/v1/enterPaymentPin',
    name: 'EnterGlobalPaymentPin',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/TerminalUser/EnterGlobalPaymentPin.vue')
  },
  {
    path: '/v1/scanner',
    name: 'V1Scanner',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/V1/Scanner.vue')
  },
  {
    path: '/voidTransactions',
    name: 'VoidTransactions',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/TerminalUser/VoidTransactions.vue')
  },
  {
    path: '/employeeReLogin',
    name: 'EmployeeReLogin',
    component: () => import(/* webpackChunkName: "about" */ '../components/Login/EmployeeReLogin.vue')
  },
  {
    path: '/table',
    name: 'table',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/Table.vue')
  },

]

export default routes
